import { render, staticRenderFns } from "./XlsUploader.vue?vue&type=template&id=b938fdfa&"
import script from "./XlsUploader.vue?vue&type=script&lang=js&"
export * from "./XlsUploader.vue?vue&type=script&lang=js&"
import style0 from "./XlsUploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports